import { createCycleApi } from 'core/api/apiFactory'
import { selectedCycleIdState } from 'modules/pond/stores/atom'
import { useParams, useSearchParams } from 'react-router-dom'
import { useRecoilValue } from 'recoil'

const useCycleApi = () => {
  const [searchParams] = useSearchParams()
  const { farmId, pondId } = useParams<{ farmId: string; pondId: string }>()
  const cycleId = useRecoilValue(selectedCycleIdState)
  const isMobile = searchParams.get('isMobile') == 'true'
  const cycleIdParams = searchParams.get('cycleId')
  let cycleIdToUse = cycleId
  
  if (isMobile && cycleIdParams) {
    cycleIdToUse = cycleIdParams
  }

  if (!farmId || !pondId) throw new Error('Farm ID or Pond ID is missing')

  return createCycleApi({ farmId, pondId, cycleId: cycleIdToUse })
}

export default useCycleApi
